import React, { FC } from 'react';
import './index.css';

const Loader: FC = () => {
    return (
        <div className="loader">
            <img src="/images/splash.png" alt="" className="main-logo"/>
            <img src="/images/splash2.png" alt=""  className="sub-logo"/>
        </div>
    );
};

export default Loader;